module.exports = __webpack_public_path__ + "static/media/locMap.2f4ee831.svg";